import {Reducer} from "redux";
import {TeamState} from "../constants";
import {TeamActions, TeamActionTypes,} from "../actions/types";

const initialState: TeamState = {
    value: [],
    searchValue: [],
    ofLeague: [],
    player: undefined,
    players: {},
    statistics: [],
    statisticsDetail: [],
    error: null,
    squad: {},
    positions: [],
    status: 'idle',
    squadStatus: 'idle'
};
const reducer: Reducer<TeamState> = (
    // eslint-disable-next-line default-param-last
    state = initialState,
    action: TeamActions
) => {
    switch (action.type) {
        case TeamActionTypes.FETCH_POSITIONS:
            return {
                ...state,
                status: 'loading'
            };
        case TeamActionTypes.FETCH_POSITIONS_ERROR:
            return {
                ...state,
                status: 'failed',
                error: action.payload
            }
        case TeamActionTypes.FETCH_POSITIONS_SUCCESS:
            return {
                ...state,
                status: 'idle',
                positions: action.payload
            }
        default: {
            return state;
        }
    }
};

export {reducer as teamReducer};
